import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import DatePicker from "./DatePicker";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type

var TimePicker = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(DatePicker, _extends({}, props, {
      picker: "time",
      mode: undefined,
      ref: ref
    }))
  );
});
TimePicker.displayName = "TimePicker";
export default TimePicker;